import { InputWidget } from 'src/components/widget/inputWidget/InputWidget';
import { lang } from 'src/utils';

export const AnimationStyleSelector = ({
  onChange,
}: {
  onChange?: (value: string) => void;
}) => {
  const handleOnChange = (value: unknown) => {
    if (onChange) {
      onChange(value as string);
    }
  };

  return (
    <InputWidget
      label={lang.productAnimation.styleText}
      value={lang.productAnimation.animationTypes.fadeIn}
      onChange={handleOnChange}
      disabled
    />
  );
};
